<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>ASSIGNMENT 4th SEMESTER JUNE 22</h2>
            <!--</div><div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>-->
        </div>
        <!-- <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>-->
    </div>
</div>

<div class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="about-text-container">
                    <h4 style="background: #29176d;color: white;padding: 21px; margin-bottom:15px">ASSIGNMENT 4th
                        SEMESTER JUNE 22</h4>
                    <div class="rightcategory_box">

                        <div class="blog_box">
                            <div class="blog_heading">
                                <h6 class="download_text" style="padding:8px; margin-bottom:10px">
                                    <a class="hover-underline-animation"
                                       href="assets/documents/ASSIGNMENT 4TH SEMESTER, JUNE, 22/ADBA.doc"
                                       style="font-size:18px; font-weight:400"> Assignments for ADBA</a></h6>
                            </div>
                        </div>
                        <br class="clear">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

